import { useUserRoutes } from '@/hooks';
import { useEffect, useState } from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { Box, Button, useTheme } from '@mui/material';
import { useUser } from '@/components/AuthInterceptorComponent/hooks/useUser';
import { useTranslation } from 'react-i18next';

export const RouteWrapper = ({ children }: { children: React.ReactNode }) => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [notRoutes, setNotRoutes] = useState(false);
  const { data } = useUser();
  const { getRoutes } = useUserRoutes();
  const theme = useTheme();
  const { t } = useTranslation();

  const coachPhone = data?.profile?.coach_phone;

  useEffect(() => {
    getRoutes().then((data) => {
      setIsSuccess(true);
      setNotRoutes(data?.results?.length === 0);
    });
  }, []);

  if (!isSuccess) {
    return <>...</>;
  }
  if (notRoutes) {
    return (
      <>
        <h2
          style={{
            textAlign: 'center',
            fontSize: '1.5rem',
            marginBottom: '0',
          }}
        >
          {t('general.noHasCourses')}
        </h2>
        <div
          style={{
            maxWidth: '800px',
            margin: '0 auto',
          }}
        >
          <DotLottieReact
            color={theme.palette.primary.main}
            src="/not-foun-animation.lottie"
            loop
            autoplay
          />
        </div>
        <p
          style={{
            textAlign: 'center',
            fontSize: '1rem',
            marginTop: '0',
          }}
        >
          Si tienes alguna duda al respecto, comunícate con nosotros.
        </p>
        <Box
          sx={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}
        >
          <Button
            variant="contained"
            color="primary"
            href={`https://wa.me/${coachPhone}`.replace('+', '')}
            target="_blank"
            sx={{
              padding: '0.5rem 2rem',
              borderRadius: '30px',
              fontSize: '1rem',
            }}
          >
            Contactar
          </Button>
        </Box>
      </>
    );
  }
  return <div>{children}</div>;
};
